import { LOADER } from '../types/loader';

export const setLoader = (payload: boolean) => ({
  type: LOADER,
  payload,
});
